export const abbreviateAddress = (
  address: string,
  startChars: number = 9,
  endChars: number = 5
): string => {
  if (address.length <= startChars + endChars) {
    return address;
  }
  const start = address.slice(0, startChars);
  const end = address.slice(-endChars);
  return `${start} ... ${end}`;
};
